import {
  getCookieValue,
} from '../utils';

const onSuccess = (response: any) => {

  return response;
};

const onError = (error: any) => {

  if (!error.response) {
    return;
  }

  switch (error.response.status) {
    case 500:
      return Promise.reject(error.response);
    default:
      break;
  }

  return Promise.reject(error.response)
};

const beforeRequestSuccess = (config: any, skipAccessToken: boolean = false) => {

  let propyAccessToken = localStorage.getItem("propyAccessToken");

  if (propyAccessToken && !skipAccessToken) {
    config.headers.Authorization = `Bearer ${propyAccessToken}`;
  }

  let hubspotCookie;

  try {
    hubspotCookie = getCookieValue("hubspotutk");
  } catch (e) {
    console.error({e})
  }

  if(hubspotCookie) {
    config.headers.hubspotutk = `${hubspotCookie}`;
  }

  return config;
};

const beforeRequestSuccessCustom = (config: any) => {
  return config;
};

const beforeRequestError = (error: any) => {
  return Promise.reject(error);
};

export {onSuccess, onError, beforeRequestSuccess, beforeRequestSuccessCustom, beforeRequestError}
